import * as React from 'react';

import { connect } from 'react-redux';

import ListPerformanceView from '../../views/library/list-performance.view';
import ListProdPerformanceView from '../../views/library/list-prod-performance.view';

import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IPerformance } from '../../custom/classes/production';
import { isGeneralAdmissionPerformance, isMixedPackage } from '../../helpers/cart-helpers';
import { IPackageListingAppState } from '../../redux-state';
import { addItemToCart, removeItemFromCart, selectPerformance, toggleMiniCart } from '../../redux-state/actions/package-listing.actions';

interface IListPerformanceExternalProps {
    performance: IPerformance;
    allowReserve: boolean;
    showReserveButton: boolean;
}

interface StateToProps {
    text: IPackageListingAppText;
    performanceInCart: boolean;
    isFixedPackage: boolean;
    useUnSeatedReservation: boolean;
}

interface DispatchToProps {
    selectPerformance: (performance: IPerformance, unseated: boolean) => void;
    removeFromCart: (itemId: number) => void;
}

export type ListPerformanceProps = IListPerformanceExternalProps & StateToProps & DispatchToProps;


export class ListPerformanceBase extends React.Component<ListPerformanceProps, any> {

    constructor(props: ListPerformanceProps) {
        super(props);

        this.state = {
            showPerformances: false
        };
    }
    render() {
        if (this.props.isFixedPackage) {
            return <ListProdPerformanceView {...this.props} />
        }
        return (
            <ListPerformanceView {...this.props} />
        )
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListPerformanceExternalProps): StateToProps {
    let useUnSeatedReservation = state.packageListingSettings.useUnseatedReservation;
    if (isMixedPackage(state)) {
        useUnSeatedReservation = isGeneralAdmissionPerformance(state, ownProps.performance.performanceId);
    }

    return {
        useUnSeatedReservation: useUnSeatedReservation,
        isFixedPackage: state.packageListingSettings.isFixed,
        text: state.packageListingText,
        performanceInCart: state.packageListingSettings.isFixed ? false : Array.from(state.packageListing.cartItems.keys()).filter(perfId => perfId == ownProps.performance.performanceId).length > 0
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        removeFromCart: (itemId: number) => {
            dispatch(removeItemFromCart(itemId));

        },
        selectPerformance: (performance: IPerformance, unseated: boolean) => {
            if (unseated) {
                dispatch(selectPerformance(performance));
            } else {
                dispatch(addItemToCart(performance.performanceId));
            }
            dispatch(toggleMiniCart(true));
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ListPerformanceBase);